<route lang="json">
{
  "name": "classroom_screen-public-author-info"
}
</route>
<script setup lang="ts">
import * as screensApis from "@/apis/classroomScreen/screens";
import InfoModal from "@/components/InfoModal.vue";
import {
  type ClassroomScreenScreen,
  type ClassroomScreenPage,
} from "@/services/fobizzToolsApi";
import { type User } from "@/services/orval/internalApiV1";
import { useClassroomScreenStore } from "@/stores/classroomScreen";
import { AccordionItems } from "@/types";

const router = useRouter();
const userStore = useUserStore();
const route = useRoute("classroom_screen-public-author-info");
const props = defineProps<{
  item: ClassroomScreenScreen;
  page: ClassroomScreenPage;
}>();
const isOpen = ref(true);

const appsStore = useAppsStore();
const app = appsStore.findAppByNamespace("classroom_screen");

// we assume that the store is initialized by the parent component
const screenStore = useClassroomScreenStore();

const isAuthor = computed(() => {
  return props.item.userId === (userStore.user as User)?.toolsUserId;
});

const handleInfoModalUpdate = (html: string) => {
  screenStore.updateScreen({ ...props.item, info: html });
  screensApis.update(props.item.id, { info: html });
};

const pageShowRouteName = computed(() =>
  route.name === "classroom_screen-public-author-info"
    ? "classroom_screen-public-page-show"
    : "classroom_screen-page-show"
);

const handleHide = () => {
  isOpen.value = false;
};

const handleHidden = () => {
  router.push({
    name: pageShowRouteName.value,
    params: { id: props.item.id, pageId: props.page.id },
    query: route.query,
  });
};
</script>

<template>
  <InfoModal
    :open="isOpen"
    :html-content="item.info || ''"
    :is-author="isAuthor"
    :item="item"
    :app="app"
    :edit-categories-link="{
      name: 'classroom_screen-share',
      params: { id: item.id, pageId: page.id },
      query: {
        openSection: AccordionItems.RecommendedFor,
      },
    }"
    @update="handleInfoModalUpdate"
    @hide="handleHide"
    @hidden="handleHidden"
  >
  </InfoModal>
</template>
